<template>
    <div >
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('ItemsReceivedListRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="ItemsReceivedList"
          :ReportName="'ItemsReceivedList'"
          :ReportTitle="$t('ItemsReceivedListRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
  
    export default Vue.extend({
        name: "ItemsReceivedListRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          recNo: Number,
          repParams: Object
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                dateFrom: null,
                dateTo:null,
                reportParams: [],
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onClickShowReport() {
              this.isParamVisible = false

              this.reportParams = []
              this.reportParams.push({ paramName: 'pStartDate', paramValue: this.repParams.DateFrom})
              this.reportParams.push({ paramName: 'pEndDate', paramValue: this.repParams.DateTo})
              this.reportParams.push({ paramName: 'pRecNo', paramValue: this.repParams.recNo})
              this.reportParams.push({ paramName: 'pLocations', paramValue: this.repParams.Locations})
              this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.repParams.SearchCriteria})
              this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})

              this.isReportVisible = true
              this.$refs.ItemsReceivedList.buildDocument(this.reportParams)
            }
        },
          mounted () {
            this.onClickShowReport();
          }
          
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
